import React from 'react';
import { Fragment } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeart } from '@fortawesome/free-solid-svg-icons';
import { faHeart as faHeartEmpty } from '@fortawesome/free-regular-svg-icons';
import { UserShape } from '../shapes';
import PropTypes from 'prop-types';


export default class TackLikeButton extends React.Component {
  static propTypes = {
    likedBy: PropTypes.object,
    tackId: PropTypes.string,
    user: UserShape,
    onLikeTack: PropTypes.func,
    onUnLikeTack: PropTypes.func
  }

  state = {
    isLiked: this.props.likedBy.includes(this.props.user.get('slug')),
    likesCount: this.props.likedBy.size
  }

  render() {
    if (this.props.user.get('loggedIn')) {
      return (
        <Fragment>
          { this.renderTackLikeButton() }<span className='like-right-spacer'></span>{ this.state.likesCount }
        </Fragment>
      );
    } else {
      return null;
    }
  }

  renderTackLikeButton() {
    if (this.state.isLiked) {
      return (
        <a href='#' className='like' onClick={ e => this.onUnLike(e) }>
          <FontAwesomeIcon icon={ faHeart } size='lg' className='like' />
        </a>
      )
    } else {
      return (
        <a href='#' className='like' onClick={ e => this.onLike(e)}>
          <FontAwesomeIcon icon={ faHeartEmpty } size='lg' />
        </a>
      )
    }
  }

  onLike(e) {
    e.preventDefault();
    this.setState({ isLiked: true, likesCount: (this.state.likesCount + 1) });
    this.props.onLikeTack(this.props.tackId);
  }

  onUnLike(e) {
    e.preventDefault();
    const likesCount = Math.max(0, (this.state.likesCount - 1));
    this.setState({ isLiked: false, likesCount: likesCount });
    this.props.onUnLikeTack(this.props.tackId);
  }
}



// WEBPACK FOOTER //
// ./src/components/tack_like_button.jsx